export const urlToObj = async(url, photoName) => {
    let response = await fetch(url)
    let blob = await response.blob()
    const file = new File([blob], photoName, {type: blob.type})
    return file
}